import { createBaseFeed } from "../../factory/core/createBaseFeed.js";
import "@universityofmaryland/web-builder-library";
import "@universityofmaryland/web-styles-library";
import "@universityofmaryland/web-styles-library/typography";
import "@universityofmaryland/web-utilities-library/theme";
import "@universityofmaryland/web-elements-library";
import { eventsDisplayStrategy } from "../../strategies/display/events.js";
import "@universityofmaryland/web-elements-library/composite";
import "@universityofmaryland/web-utilities-library/elements";
import "@universityofmaryland/web-utilities-library/network";
import { eventsFetchStrategy } from "../../strategies/fetch/events.js";
import "../../strategies/fetch/news.js";
import "../../strategies/fetch/experts.js";
import "../../strategies/fetch/inTheNews.js";
import { gridGapLayout } from "../../strategies/layout/grid.js";
import "@universityofmaryland/web-elements-library/layout";
const eventsGrid = (props) => createBaseFeed({
  ...props,
  enableCategoryFallback: true,
  fetchStrategy: eventsFetchStrategy,
  displayStrategy: eventsDisplayStrategy,
  layoutStrategy: gridGapLayout,
  imageConfig: (entry) => {
    const imageUrl = entry.image?.[0]?.url;
    const altText = entry.image?.[0]?.altText;
    if (!imageUrl || !altText) return null;
    return {
      imageUrl,
      altText,
      linkUrl: entry.url,
      linkLabel: "University of Maryland Event"
    };
  }
});
export {
  eventsGrid
};
//# sourceMappingURL=grid.js.map
